export function getExportBlobByContent(content: string, options: { type: string }) {
  return new Blob([content], { type: `text/${options.type};charset=utf-8;` })
}
